<template>
    <div id="timeline">
        <b-tabs
            :nav-class="['timeline-tabs', { 'border-0': !showContent }]"
            :content-class="{ 'd-none': !showContent }"
        >
            <slot />
        </b-tabs>
    </div>
</template>

<script>
import { BTabs } from 'bootstrap-vue'

export default {
    components: { BTabs },
    props: {
        showContent: { type: Boolean, default: false },
    }
}
</script>

<style scoped>
    #timeline .tab-pane {
        margin-top: -1rem;
        padding: 15px;
    }
    .timeline-tabs {
        justify-content: space-between;
        border: none;
        display: flex;
        flex-wrap: nowrap;
        height: auto;
        border-radius: 100px;
        align-items: center;
        align-content: center;
        margin: 0;
        border-radius: 0;
        border-bottom: 1px solid #e2e6ef;
        padding: 1.25rem 0;
    }
    .timeline-tabs > li {
        flex: 1;
        position: relative;
        margin: 0 !important;
        float: none;
        color: #333;
    }
    .timeline-tabs > li:not(:last-child):before {
        content: '';
        position: absolute;
        top: calc(50% - 1px);
        left: 50%;
        width: 100%;
        height: 2px;
        background: currentColor;
    }
    .timeline-tabs > li > a, .timeline-tabs > li > a:hover,
    .timeline-tabs > li > a.active, .timeline-tabs > li > a.active:hover,
    .timeline-tabs > li > a.nav-link, .timeline-tabs > li > a.nav-link:hover {
        color: currentColor !important;
        border: none !important;
        background: none !important;
        text-align: center;
        display: flex;
        flex-direction: column;
        height: 70px;
        padding: 0;
    }
    .timeline-tabs > li > a[data-info]:before {
        content: attr(data-info);
        width: 80px;
        background: #f1f4f6;
        z-index: 2;
        line-height: 1;
        height: 23px;
        padding: 0.2rem 0;
        font-weight: 500;
    }
    .timeline-tabs > li > a[data-info]:after {
        width: 37px;
        height: 14px;
    }
    .timeline-tabs > li > a:before, .timeline-tabs > li > a:after {
        content: '';
        width: 12px;
        height: 12px;
        border-radius: 10px;
        background: currentColor;
        border: 2px solid currentColor;
        margin: auto;
        display: inline-block;
    }
    .timeline-tabs > li > a:after {
        transform: scale(0);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%) scale(0);
        width: 12px;
        height: 12px;
        background: #FFF;
        border: 4px solid currentColor;
        opacity: 0.3;
        transition: transform 0.3s;
    }

    .timeline-tabs > li > a.active:after {
        transform: translateX(-50%) translateY(-50%) scale(2.5);
    }

    .timeline-tabs > li:last-child > a:before {
        background: #f0f3f5;
    }

    .timeline-tabs > li > a > span {
        bottom: auto;
        top: 0;
    }
    .timeline-tabs > li > a > span {
        position: absolute;
        top: -4px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        color: #333 !important;
        box-shadow: 0px 0px 0px 0px currentColor;
        transition: box-shadow 0.3s;
        white-space: nowrap;
    }
    .timeline-tabs > li > a > span:after {
        position: absolute;
        bottom: 0;
        left: 50%;
        content: attr(data-time);
        font-size: 10px;
        transform: translateX(-50%);
    }
    .timeline-tabs > li > a.active:before {
        box-shadow: 0px 0px 10px -5px currentColor;
    }
    .timeline-tabs > li > a.active > span {
        font-weight: 600;
    }

    #timeline >>> .nav-link:after {
        display: none !important
    }

    #timeline >>> .nav-tabs {
        padding: 1rem 0.5rem;
    }
</style>
